/**
 * D752 (doc 34 K26): the login a `PHONE_HAS_LOGIN` refusal of `register` names (the problem's `existingLogin`, kept by that call), validated - a masked
 * first name of at most 32 characters and realms as fixed tokens; anything else is dropped. Undefined for any other error.
 */
export function existingLoginOf(error) {
    if (error.reasonCode !== 'PHONE_HAS_LOGIN')
        return undefined;
    const raw = error.members?.existingLogin;
    const hint = typeof raw === 'object' && raw !== null && !Array.isArray(raw) ? raw : {};
    const realms = Array.isArray(hint.realms) ? hint.realms.filter((r) => typeof r === 'string' && /^[A-Z_]{1,32}$/.test(r)) : [];
    const name = typeof hint.firstNameMasked === 'string' && hint.firstNameMasked.length > 0 && hint.firstNameMasked.length <= 32 ? hint.firstNameMasked : undefined;
    return { ...(name !== undefined ? { firstNameMasked: name } : {}), realms };
}
export const WORK_LINE_VIEWS = ['RIDE_CAR', 'RIDE_MOTO', 'RIDE_VAN', 'RIDE_UTILITY', 'RIDE_TRUCK', 'RIDE_BIKE', 'FOOD', 'SEND'];
export const VEHICLE_CLASS_VIEWS = ['bike', 'moto', 'car', 'van', 'utility', 'truck'];
/** Whether the login has no driver record yet (open the sign-up). */
export const isNotRegistered = (view) => view.state === 'NOT_REGISTERED';
const enc = encodeURIComponent;
const qs = (params) => {
    const parts = Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== false).map(([k, v]) => `${k}=${enc(String(v))}`);
    return parts.length > 0 ? `?${parts.join('&')}` : '';
};
/** The operator's registration of drivers (`driver:view` / `driver:register` / `document:view`). */
export class DriverRegistryAdminApi {
    client;
    constructor(client) {
        this.client = client;
    }
    form(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-registry/form${qs({ marketId })}`, auth: true });
    }
    grid(query) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-registry${qs({ ...query })}`, auth: true });
    }
    workLines(marketId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-registry/work-lines${qs({ marketId })}`, auth: true });
    }
    /** D752 (doc 34 K26): `adopted: true` when the phone already had a login (a rider, or an unfinished provider-app sign-up) - the record is made on it. */
    register(input) {
        return this.client.request({ method: 'POST', path: '/v1/admin/driver-registry', body: input, auth: true, problemMembers: ['existingLogin'] });
    }
    /** D723: attach a rider's driver invitation code to an existing record (inside the governed attribution window). */
    attachReferral(driverId, code, categoryCode) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-registry/${encodeURIComponent(driverId)}/referral`, body: { code, categoryCode }, auth: true });
    }
    record(driverId) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-registry/${enc(driverId)}`, auth: true });
    }
    update(driverId, input) {
        return this.client.request({ method: 'PATCH', path: `/v1/admin/driver-registry/${enc(driverId)}`, body: input, auth: true });
    }
    recordEvidence(driverId, input) {
        return this.client.request({ method: 'POST', path: `/v1/admin/driver-registry/${enc(driverId)}/evidence`, body: input, auth: true });
    }
    documents(query) {
        return this.client.request({ method: 'GET', path: `/v1/admin/driver-documents${qs({ ...query })}`, auth: true });
    }
}
/** The driver's own consolidated checklist and address (DRIVER realm, own session only). */
export class DriverReadinessApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** The checklist of a driver record, or `NOT_REGISTERED` for a login with none yet (D752; narrow with {@link isNotRegistered}). */
    get() {
        return this.client.request({ method: 'GET', path: '/v1/driver/readiness', auth: true });
    }
    setAddress(address) {
        return this.client.request({ method: 'PUT', path: '/v1/driver/address', body: { address }, auth: true });
    }
}
//# sourceMappingURL=driver-registry.js.map